export default __webpack_public_path__ + "static/media/Q_Forms.b1242904.png";